<div class="grid-container margin-top">
  <form [formGroup]="form">
    <div class="grid-x">
      <div class="cell large-12 medium-12 small-12">
        <upload-view-files [uniqueId]="'file-upload'" [componentLabel]="'Upload Formatted File of Wells to Change Status'" [isPadded]="false" (newFilesList)="parseFile($event)" [showFileList]="false" [allowDeletion]="true"></upload-view-files>
      </div>
      @if (hasFileListing) {
        <div class="cell large-12 medium-12 small-12">
          @for (file of uploadedFiles; track file) {
            <div class="flex">
              <uploaded-file [allowFileDeletion]="true" [file]="file" (fileDeleted)="deleteFile($event)"></uploaded-file>
            </div>
          }
        </div>
      }
      <div class="cell large-12 medium-12 small-12">
        <text-loader [run]="isParsing && hasFileListing" [text]="'Reading File'" [interval]="500" [tickType]="'.'"></text-loader>
      </div>
      @if (!isParsing && hasFileListing) {
        <div class="cell large-12 medium-12 small-12 bold">
          Parsed Rows:<span [ngClass]="{ 'red': form?.get('parsedData')?.invalid }">*</span>
        </div>
        @if (parsedData && parsedData.length > 0) {
          <div class="cell large-12 medium-12 small-12 margin-bottom">
            <ag-grid-angular class="data-grid " [gridOptions]="parsedGridOptions" [rowData]="parsedData" [statusBar]="statusBar" aria-label="Submit Bulk Well Update"></ag-grid-angular>
          </div>
        } @else {
          <ng-template [ngTemplateOutlet]="noValid"></ng-template>
        }
        <div class="cell large-12 medium-12 small-12 bold">
          Errors:
        </div>
        @if (errorData && errorData.length > 0) {
          <div class="cell large-12 medium-12 small-12">
            <ag-grid-angular class="data-grid " [gridOptions]="errorGridOptions" [rowData]="errorData" [statusBar]="statusBar" aria-label="Submit Bulk Well Update"></ag-grid-angular>
          </div>
        } @else {
          <ng-template [ngTemplateOutlet]="noErrors"></ng-template>
        }
      }
      <div class="cell large-12 medium-12 small-12 bold">
        Please provide a reason for this update:
      </div>
      <div class="cell large-12 medium-12 small-12 minor-margin-top">
        <text-editor [required]="false" (formBuilt)="editorBuilt($event)"></text-editor>
      </div>
      <div class="cell large-12 medium-12 small-12 text-align-center margin-top">
        <span class="margin-right">
          <button class="button" (click)="cancel()">Cancel</button>
        </span>
        <span class="margin-left">
          <button class="button" (click)="submit()" [disabled]="!hasFileListing || form.invalid">Submit</button>
        </span>
      </div>
    </div>
  </form>
  <a style="display:none;" #downloadLink></a>
</div>